import React, { FC, useContext, useEffect, useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Drawer from '@material-ui/core/Drawer'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import MenuIcon from '@material-ui/icons/Menu'

import Section from '../components/web/Section'
import Link from '../components/widgets/Link'
import ClickLink from '../components/widgets/ClickLink'
import LayoutContext from '../contexts/Layout'

import withAppLinks from '../hooks/withAppLinks'
import withFullRoute from '../hooks/withFullRoute'

import routerActions from '../store/modules/router'
import routerSelectors from '../store/selectors/router'

import {
  IAppLink,
} from '../types/layout'

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.background.default,
      transition: 'background-color 300ms ease-in',
    }
  },
  root: {
    ...theme.mixins.toolbar,
  },
  appbar: {
    backgroundColor: 'rgba(255,255,255,0.95)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  navButton: {
    textAlign: 'left',
  },
  navButtonFullWidth: {
    width: '100%',
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '720px',
    paddingLeft: '0px',
  },
  toolbarMiddle: {
    justifyContent: 'center',
  },
  toolbarLeft: {
    justifyContent: 'flex-start',
  },
  linkLeft: {
    flexGrow: 1,
    textAlign: 'left'
  },
  linkMiddle: {
    flexGrow: 1,
    textAlign: 'center'
  },
  linkRight: {
    flexGrow: 1,
    textAlign: 'right'
  },
  link: {
    color: '#000',
    textDecoration: 'none',
    minHeight: '40px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  linkContainerLeft: {
    justifyContent: 'flex-start',
  },
  linkActive: {
    fontWeight: 'bold',
    color: theme.palette.secondary.main,
  },
  content: {
    //height: '100%',
    //minHeight: '100%',
  },
  navmenu: {
    minWidth: '250px',
  }
}))

const LayoutWeb: FC = ({
  children,
}) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const [ navOpen, setNavOpen ] = useState(false)
  const route = useSelector(routerSelectors.route)
  const {
    isBigScreen,
    allLinks,
    topbarLinks,
  } = withAppLinks()
  const fullRoute = withFullRoute()

  const {
    setImageSizeElement,
  } = useContext(LayoutContext)

  const onClickMenuLink = useCallback((link: IAppLink) => {
    if(link.page) {
      dispatch(routerActions.navigateTo(link.page, link.params))
    }
    else if(link.handler) {
      link.handler()
    }
    else if(link.url) {
      window.location.href = link.url
    }
  }, [])

  useEffect(() => {
    const elem = document.querySelector('#pannft-appbar') as HTMLDivElement
    if(elem) {
      setImageSizeElement('appbar', elem)
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [
    route,
  ])

  return (
    <>
      <div id="pannft-appbar" className={ classes.root }>
        <AppBar position="fixed" className={ classes.appbar }>
          <Toolbar className={ classnames(classes.toolbar, isBigScreen ? classes.toolbarMiddle : classes.toolbarLeft) }>
            <div className={ classnames(classes.link, classes.linkMiddle, !isBigScreen ? classes.linkContainerLeft : '') }>
              <IconButton
                onClick={ () => setNavOpen(true) }
              >
                <MenuIcon />
              </IconButton>
            </div>
            {
              topbarLinks.map((link, linkIndex) => {
                if(link.page) {
                  return (
                    <Link
                      key={ linkIndex }
                      name={ link.page }
                      className={
                        classnames(classes.link, {
                          [classes.linkMiddle]: true,
                          [classes.linkActive]: fullRoute?.group == link.group,
                        })
                      }
                    >
                      { link.title }
                    </Link>
                  )
                }
                else if(link.handler) {
                  return (
                    <ClickLink
                      key={ linkIndex }
                      className={ classnames(classes.link, classes.linkMiddle) }
                      onClick={ link.handler }
                    >
                      { link.title }
                    </ClickLink>
                  )
                }
                else if(link.url) {
                  return (
                    <Link
                      key={ linkIndex }
                      className={ classnames(classes.link, classes.linkMiddle) }
                      url={ link.url }
                    >
                      { link.title }
                    </Link>
                  ) 
                }
              })
            }
          </Toolbar>
        </AppBar>
        <Drawer 
          open={ navOpen }
          onClose={ () => setNavOpen(false) }
        >
          <List component="nav" className={ classes.navmenu }>
            {
              allLinks.map((link, i) => {
                return (
                  <React.Fragment key={ i }>
                    {
                      link.divider && (
                        <Divider />
                      )
                    }
                    <ListItem 
                      button 
                      onClick={ () => {
                        setNavOpen(false)
                        onClickMenuLink(link) 
                      }}
                    >
                      <ListItemText 
                        primary={ link.title }
                        className={ classnames({
                          [classes.linkActive]: link.page && route?.name == link.page,
                        })}
                      />
                    </ListItem>
                  </React.Fragment>
                )
              })
            }
            
          </List>
        </Drawer>
      </div>
      <div className={classes.content}>
        {children}
      </div>
    </>
  )
}

export default LayoutWeb